function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 2h46v56H9z",
  fill: "gray"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 50.959c.498.022.997.041 1.5.041C30.106 51 46 33.763 46 12.5c0-3.642-.476-7.161-1.348-10.5H9z",
  fill: "#999"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13 6h38v48H13z",
  fill: "#ccc"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13 50.894C31.438 49.502 46 32.85 46 12.5c0-2.219-.196-4.385-.532-6.5H13z",
  fill: "#ebebeb"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13 10h30v22H13z",
  fill: "#c4ac83"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M43 27.987V10H13v22h28.107A39.697 39.697 0 0043 27.987z",
  fill: "#d0bd9c"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M19 36h26v14H19z",
  fill: "#c4ac83"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M38.614 36H19v13.867c7.913-2.11 14.784-7.086 19.614-13.867z",
  fill: "#dccdb5"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M23 40h10v6H23z",
  fill: "gray"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M23 46h4.96A35.64 35.64 0 0033 42.255V40H23z",
  fill: "#b3b3b3"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  fill: "gray"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 21,
  r: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 19h-6.422c.268.613.422 1.288.422 2s-.154 1.387-.422 2H35a2 2 0 100-4zM11 58h6v4h-6zM47 58h6v4h-6z"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M38 13h2v2h-2zM38 27h2v2h-2zM16 13h2v2h-2zM16 27h2v2h-2zM36 40h2v2h-2zM40 40h2v2h-2zM36 44h2v2h-2zM40 44h2v2h-2z",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M55 1H9a1 1 0 00-1 1v56a1 1 0 001 1h1v3a1 1 0 001 1h6a1 1 0 001-1v-3h28v3a1 1 0 001 1h6a1 1 0 001-1v-3h1a1 1 0 001-1V2a1 1 0 00-1-1zM16 61h-4v-2h4zm36 0h-4v-2h4zm2-4H10V3h44z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M13 55h38a1 1 0 001-1V6a1 1 0 00-1-1H13a1 1 0 00-1 1v48a1 1 0 001 1zM50 7v46H14V33h29a1 1 0 001-1V10a1 1 0 00-1-1H14V7zM14 31V11h28v20z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M35 18h-5.812A5.999 5.999 0 0024 15c-3.309 0-6 2.691-6 6s2.691 6 6 6a5.999 5.999 0 005.188-3H35c1.654 0 3-1.346 3-3s-1.346-3-3-3zm-11 7c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm11-3h-5.09c.055-.326.09-.659.09-1s-.035-.674-.09-1H35a1.001 1.001 0 010 2zM38 13h2v2h-2zM38 27h2v2h-2zM16 13h2v2h-2zM16 27h2v2h-2zM18 36v14a1 1 0 001 1h26a1 1 0 001-1V36a1 1 0 00-1-1H19a1 1 0 00-1 1zm2 1h24v12H20z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M33 39H23a1 1 0 00-1 1v6a1 1 0 001 1h10a1 1 0 001-1v-6a1 1 0 00-1-1zm-1 6h-8v-4h8zM36 40h2v2h-2zM40 40h2v2h-2zM36 44h2v2h-2zM40 44h2v2h-2z"
});

function SvgTrove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrove);
export default __webpack_public_path__ + "static/media/trove.caad8f08.svg";
export { ForwardRef as ReactComponent };